import { useEffect, useRef, useState } from "react"
const { createPopupHistoryId, hasPopup, registerPopup, requestClose, unregisterPopup } = globalThis.DuscoShared.popupHandler

type ModalStateValue<T> = boolean | T
type UseModalStateReturn<T> = readonly [ModalStateValue<T>, (data?: T) => void, () => void]

export default function useModalState<T = never>(initialState: ModalStateValue<T> = false as ModalStateValue<T>): UseModalStateReturn<T> {
    const [isOpen, setIsOpen] = useState<ModalStateValue<T>>(initialState)
    const historyIdRef = useRef(createPopupHistoryId('modal-state'))
    const isActive = Boolean(isOpen)

    const forceClose = () => {
        unregisterPopup(historyIdRef.current)
        setIsOpen(false)
    }

    const openPopup = (data?: T) => {
        setIsOpen((data ?? true) as ModalStateValue<T>)
    }

    const closePopup = () => {
        if (!isActive) {
            forceClose()
            return
        }

        requestClose(historyIdRef.current, forceClose)
    }

    useEffect(() => {
        if (!isActive) {
            unregisterPopup(historyIdRef.current)
            return
        }

        if (!hasPopup(historyIdRef.current)) {
            registerPopup({ id: historyIdRef.current, onClose: forceClose })
        }

        return () => {
            unregisterPopup(historyIdRef.current)
        }
    }, [isActive])

    return [isOpen, openPopup, closePopup] as const
}